module.exports = __webpack_public_path__ + "img/gw.6241752e.svg";